import { MenuItem } from 'primereact/menuitem';

export const createMenuItem = (
  label: string,
  additionalClasses = '',
  command: () => void,
): MenuItem => ({
  label,
  className: `hover:bg-thirty h-[43px] leading-[43px] rounded-[5.16px] pl-[7.44px] font-[500] text-[12.38px] cursor-pointer ${additionalClasses}`,
  command,
});
